module.exports = __webpack_public_path__ + "img/x.ed53fa02.jpg";